// Panel unificado de dimensiones: Categorías, Proveedores, Segmentos, Industrias

import React, { useState } from "react";
import CategoriesAdmin from "./CategoriesAdmin";
import SuppliersAdmin from "./SuppliersAdmin";
import SegmentosAdmin from "./SegmentosAdmin";
import IndustriasAdmin from "./IndustriasAdmin";
import OrigenesProspeccionAdmin from "./OrigenesProspeccionAdmin";
import CanalesAdmin from "./CanalesAdmin";
import MotivosRechazoAdmin from "./MotivosRechazoAdmin";

const TABS = [
    { key: "categorias",      label: "Categorías"  },
    { key: "proveedores",     label: "Proveedores"  },
    { key: "segmentos",       label: "Segmentos"    },
    { key: "industrias",      label: "Industrias"   },
    { key: "origenes",        label: "Orígenes de prospección" },
    { key: "canales",         label: "Canales" },
    { key: "motivosRechazo",  label: "Motivos de rechazo" },
];

const DimensionesAdmin = () => {
    const [active, setActive] = useState("categorias");

    return (
        <section style={{ padding: "0 0 40px" }}>
            {/* Tab pills */}
            <div style={{
                display: "flex",
                gap: 8,
                padding: "24px 20px 0",
                borderBottom: "2px solid #f0eaee",
                flexWrap: "wrap",
            }}>
                {TABS.map((tab) => {
                    const isActive = active === tab.key;
                    return (
                        <button
                            key={tab.key}
                            onClick={() => setActive(tab.key)}
                            style={{
                                padding: "9px 22px",
                                borderRadius: "8px 8px 0 0",
                                border: "none",
                                background: isActive ? "#9f0059" : "transparent",
                                color: isActive ? "#fff" : "#9f0059",
                                fontWeight: 700,
                                fontSize: 14,
                                cursor: "pointer",
                                borderBottom: isActive ? "2px solid #9f0059" : "2px solid transparent",
                                marginBottom: -2,
                                transition: "background 0.15s",
                            }}
                        >
                            {tab.label}
                        </button>
                    );
                })}
            </div>

            {/* Contenido del tab activo */}
            <div>
                {active === "categorias"  && <CategoriesAdmin />}
                {active === "proveedores" && <SuppliersAdmin  />}
                {active === "segmentos"   && <SegmentosAdmin  />}
                {active === "industrias"  && <IndustriasAdmin />}
                {active === "origenes"       && <OrigenesProspeccionAdmin />}
                {active === "canales"        && <CanalesAdmin />}
                {active === "motivosRechazo" && <MotivosRechazoAdmin />}
            </div>
        </section>
    );
};

export default DimensionesAdmin;
